setTimeout(()=>{
    const preFont = document.createElement('link');
    preFont.rel = 'preconnect';
    preFont.href = 'https://fonts.googleapis.com';

    const font = document.createElement('link');
    font.rel = 'preconnect';
    font.href = 'https://fonts.gstatic.com';
    font.crossorigin = 'anonymous';

    const fontUrl = document.createElement('link');
    fontUrl.href = "https://fonts.googleapis.com/css2?family=PT+Sans&family=Roboto+Condensed&display=swap";
    fontUrl.rel = 'stylesheet';

    document.head.append(preFont, font, fontUrl);
},100)

